import { createRoot } from 'react-dom/client';
import App from './App';

const container = document.getElementById('root')!;
const root = createRoot(container);
root.render(<App />);

// calling IPC exposed from preload script
/* window.electron.ipcRenderer.once('ipc-main', (arg) => {
  console.log(arg);
}); */
// window.electron.ipcRenderer.sendMessage('ipc-main', ['ping']);
